import React from 'react';

import NavDesktop from 'layouts/header/nav/nav.desktop';
import SearchDesktop from 'layouts/header/search/search.desktop';
import Cabinet from 'components/cabinet/cabinet';
import Link from 'atomic/link/link';

import logo from 'assets/icons/logo.inline.svg';

import './header.desktop.scss';

interface HeaderDesktopProps {
    isHomepage?: boolean;
}

const HeaderDesktop: React.FC<HeaderDesktopProps> = ({ isHomepage }) => {
    const homeLink = (
        <Link className="header__logo-link" href="/" title="OPINEO.pl"
            wrapper={true}
        >
            <img className="header__logo-img" src={logo} alt="Sprawdź opinie sklepów i produktów – Opineo"
                width={186} height={43}
            />
        </Link>
    );

    return (
        <header className="header">
            <div className="header__container container">
                {isHomepage
                    ? (
                        <h1 className="header__logo-header">
                            {homeLink}
                        </h1>
                    )
                    : homeLink}
                <NavDesktop className="header__nav" />
                <SearchDesktop className="header__search" />
                <Cabinet className="header__cabinet" />
            </div>
        </header>
    );
};

export default HeaderDesktop;
